import React, { Component } from "react";
import { FormValidate } from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import TextField from "../../../../../components/inputs/textfield";
import Snackbar from "../../../../../components/snackbar/snackbar";
import { admin_publications_create } from "../../../admin.api";
import "./dialog.css";
import CommonForm from "../../../../../components/commonform/commonForm";
import TextEditer from "../../../../../components/inputs/texteditor";

let required = [
  "publication_title",
  "title_ma",
  "publisher",
  "publisher_ma",
  "description",
  "description_ma",
  "upload_image",
];

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData,
      edit: props.edit,
      submitted: false,
      fileChanged: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
    });
  };
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };
  handleDatePickerChange = (e, name) => {
    let date = e?.value;
    if (date) {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: date,
        },
      });
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: null,
        },
      });
    }
  };
  normalizeDateForSubmit = (value) => {
    if (!value) {
      return null;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }
    const parts = value.split("-");
    if (parts.length === 3) {
      const [first, second, third] = parts;
      if (first.length === 4) {
        return value;
      }
      if (third.length === 4) {
        return `${third}-${second}-${first}`;
      }
    }
    return value;
  };
  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };

  handleSubmit = (e) => {
    const error = FormValidate(this.state.formData, required);
    const { edit, formData } = this.state;

    const form = new FormData();
    if (formData?.publication_title)
      form.append("publication_title", formData?.publication_title);
    if (formData?.title_ma)
      form.append("title_ma", formData?.title_ma);

    if (formData?.link) form.append("link", formData?.link);
    if (formData?.publisher) form.append("publisher", formData?.publisher);
    if (formData?.publisher_ma) form.append("publisher_ma", formData?.publisher_ma);
    if (formData?.description) form.append("description", formData?.description);
    if (formData?.description_ma) form.append("description_ma", formData?.description_ma);
    const dueDate = this.normalizeDateForSubmit(formData?.due_date);
    if (dueDate) form.append("due_date", dueDate);

    if (this.state.fileChanged && formData?.upload_image) {
      form.append("upload_image", formData?.upload_image);
    }
    if (formData?.id) form.append("publication_id", formData?.id);

    e.preventDefault();

    if (Object.keys(error).length === 0) {
      if (edit) {
        admin_publications_create(form)
          .then((res) => {
            this.setState({
              submitted: true,

              snackMessage: res.message,
              isSnackError: false,
              snackOpen: true,
            });
          })
          .catch((error) => {
            this.setState({
              submitted: false,
              snackMessage: error.message,
              isSnackError: true,
              snackOpen: true,
            });
          });
      } else {
        admin_publications_create(form)
          .then((res) => {
            this.setState({
              submitted: true,

              snackMessage: res.message,
              isSnackError: false,
              snackOpen: true,
            });
          })
          .catch((error) => {
            this.setState({
              submitted: false,
              snackMessage: error.message,
              isSnackError: true,
              snackOpen: true,
            });
          });
      }
    } else {
      this.setState({
        submitted: false,
        snackMessage: "Please fill all mandatory fields",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };
  handleSelect = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        parent_id: e.target.value,
      },
    });
  };
  handleFileChange = (e) => {
    this.setState({
      isActive: true,
    });
    try {
      const file = e.target.files && e.target.files[0];
      if (!file) {
        this.setState({
          isActive: false,
        });
        return;
      }
      const allowedExtensions = ["pdf", "doc", "docx"];
      const extension = file.name.split(".").pop().toLowerCase();
      const maxSize = 5 * 1024 * 1024;

      if (!allowedExtensions.includes(extension)) {
        this.setState({
          snackMessage: "File should be in .pdf / .doc / .docx format",
          isSnackError: true,
          snackOpen: true,
          isActive: false,
        });
        return;
      }

      if (file.size > maxSize) {
        this.setState({
          snackMessage: "File size should not exceed 5MB",
          isSnackError: true,
          snackOpen: true,
          isActive: false,
        });
        return;
      }

      this.setState({
        fileChanged: true,

        formData: {
          ...this.state.formData,
          file_name: file.name,
          [e.target.name]: file,
        },
        isActive: false,
      });
    } catch {
      this.setState({
        isActive: false,
      });
    }
  };
  handleEditorChange = (value, fieldName) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [fieldName]: value,
      },
    });
  };
  getDownloadUrl = () => {
    const { formData } = this.state;
    const { baseUrl } = this.props;
    const fileValue = formData?.upload_image;

    if (!fileValue || (typeof File !== "undefined" && fileValue instanceof File)) {
      return null;
    }

    if (typeof fileValue === "string") {
      if (/^https?:\/\//i.test(fileValue)) {
        return fileValue;
      }

      if (baseUrl) {
        const trimmedBase = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
        const cleanedPath = fileValue.startsWith("/") ? fileValue.slice(1) : fileValue;
        return `${trimmedBase}/${cleanedPath}`;
      }
      return fileValue;
    }
    return null;
  };

  render() {
    const { submitted, formData, open, edit } = this.state;
    const { view } = this.props;
    const previewUrl = this.getDownloadUrl();
    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <div className="overlay">
              <div className="publication-box">
                <Snackbar
                  message={this.state.snackMessage}
                  error={this.state.isSnackError}
                  open={this.state.snackOpen}
                  close={this.snackbarClose}
                />
                <div className="row">
                  <div className="flexDisplay">
                    <div className="diaTitleCon">
                      {edit
                        ? "Edit Publication"
                        : view
                          ? "Publication"
                          : "Add Publication"}
                    </div>
                    <div className="dia-close" onClick={this.props.handleClose}>
                      <div className="diaCloseCon">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div>
                  </div>
                  <div className="tilebar"></div>
                  <form action="">
                    <div className="row book-form">
                      <div className="content-scroll-xx">
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Title[Eng]"
                            variant="outlined"
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData?.publication_title ?? ""}
                            name="publication_title"
                            required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Title[Mal]"
                            variant="outlined"
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData?.title_ma ?? ""}
                            name="title_ma"
                            required
                          />
                        </div>

                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Link"
                            name="link"
                            variant="outlined"
                            disabled={view}
                            value={formData?.link ?? ""}
                            onChange={(e) => this.handleChange(e)}
                          />
                          <div className="file-up-helper">
                            *link must start with "https://" or "http://" ( eg: https://kspace.in/ )
                          </div>
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Publisher[Eng]"
                            name="publisher"
                            variant="outlined"
                            disabled={view}
                            value={formData?.publisher ?? ""}
                            onChange={(e) => this.handleChange(e)}
                            required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Publisher[Mal]"
                            name="publisher_ma"
                            variant="outlined"
                            disabled={view}
                            value={formData?.publisher_ma ?? ""}
                            onChange={(e) => this.handleChange(e)}
                            required
                          />
                        </div>

                        <div className="col-12">
                          <label className="mylabel">
                            Description[Eng]{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <TextEditer
                            value={formData?.description ?? ""}
                            onChange={(e) => this.handleEditorChange(e, "description")}
                            disabled={view}
                            name="description"
                            required
                          />
                        </div>
                        <div className="col-12">
                          <label className="mylabel">
                            Description[Mal]{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <TextEditer
                            value={formData?.description_ma ?? ""}
                            onChange={(e) => this.handleEditorChange(e, "description_ma")}
                            disabled={view}
                            name="description_ma"
                            required
                          />
                        </div>


                        <div className="col-12">
                          <CommonForm
                            fieldType="file"
                            required={!formData?.file_name ? true : false}
                            label="File"
                            disabled={view}
                            name="upload_image"
                            id="photo"
                            fileName={formData?.file_name}
                            accept=".pdf,.doc,.docx"
                            type="file"
                            variant="outlined"
                            onChange={this.handleFileChange}
                          />
                          {previewUrl && (
                            <div className="file-up-helper">
                              Current file:{" "}
                              <a
                                href={previewUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                              >
                                {previewUrl}
                              </a>
                            </div>
                          )}
                          <div className="file-up-helper">
                            *Upload .pdf / .doc / .docx files only (max 5MB)
                          </div>
                        </div>
                        <div className="col-12">
                          <CommonForm
                            fieldType="date"
                            label="Due Date"
                            name="due_date"
                            disabled={view}
                            value={formData?.due_date ?? ""}
                            onChange={(e) => this.handleDatePickerChange(e, "due_date")}
                            minDate={new Date()}
                            format="YYYY-MM-DD"
                          />
                        </div>
                      </div>
                      {!view && (
                        <div className="col-12">
                          <CustomButton
                            label={edit ? "Update" : "Add"}
                            disabled={submitted}
                            onClick={(e) => this.handleSubmit(e)}
                          />
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
